

<div *ngIf="!loggedIn">
        <div id="container">
            <div id="login-container">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</div>

<router-outlet ></router-outlet>
